(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  // Global modal — tetikleyici: data-modal-open="modalId"
  // Kapatma: data-modal-close, Escape, backdrop tıklaması
  DNB.Modal = {
    init: function () {
      if (document.documentElement.getAttribute("data-modal-init") === "1") return;
      document.documentElement.setAttribute("data-modal-init", "1");

      document.addEventListener("click", this._onClick.bind(this));
      document.addEventListener("keydown", this._onKeydown.bind(this));

      document.querySelectorAll(".modal-box__body").forEach(function (el) {
        el.setAttribute("data-lenis-prevent", "");
      });
    },

    open: function (id) {
      if (!id) return;

      var modalId = id.charAt(0) === "#" ? id.slice(1) : id;
      var modal = document.getElementById(modalId);
      if (!modal || !modal.classList.contains("modal-box")) return;

      this.close();
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("has-modal-open");

      if (DNB.ScrollService && DNB.ScrollService.lock) {
        DNB.ScrollService.lock();
      }

      var closeBtn = modal.querySelector(".modal-box__close, [data-modal-close]");
      if (closeBtn && closeBtn.focus) {
        try { closeBtn.focus(); } catch (err) {}
      }
    },

    close: function (modal) {
      var target = modal;

      if (!target) {
        target = document.querySelector(".modal-box.is-open");
      } else if (!target.classList.contains("modal-box")) {
        target = target.closest(".modal-box");
      }

      if (!target) return;

      target.classList.remove("is-open");
      target.setAttribute("aria-hidden", "true");

      if (!document.querySelector(".modal-box.is-open")) {
        document.documentElement.classList.remove("has-modal-open");
        if (DNB.ScrollService && DNB.ScrollService.unlock) {
          DNB.ScrollService.unlock();
        }
      }
    },

    _onClick: function (e) {
      var trigger = e.target.closest("[data-modal-open]");
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        this.open(trigger.getAttribute("data-modal-open"));
        return;
      }

      var closeEl = e.target.closest("[data-modal-close]");
      if (closeEl) {
        e.preventDefault();
        this.close(closeEl);
      }
    },

    _onKeydown: function (e) {
      if (e.key === "Escape") {
        this.close();
      }
    }
  };
})(window, document);
